function IconFacebookComponent() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.4067 12.0705C24.4063 9.76342 23.7448 7.50477 22.5006 5.56194C21.2564 3.61911 19.4816 2.07345 17.3862 1.10795C15.2909 0.142451 12.9628 -0.202468 10.6775 0.11403C8.39223 0.430528 6.24549 1.39519 4.49142 2.89381C2.73735 4.39244 1.4494 6.36227 0.780043 8.57012C0.110684 10.778 0.0879448 13.1314 0.714518 15.3518C1.34109 17.5721 2.59074 19.5665 4.31553 21.0987C6.04031 22.6309 8.16801 23.6369 10.4467 23.9975V15.5605H7.38074V12.0705H10.4467V9.41051C10.4467 6.38451 12.2467 4.71051 15.0067 4.71051C15.9113 4.72329 16.8137 4.80216 17.7067 4.94651V7.92051H16.1867C15.9273 7.88617 15.6635 7.91061 15.4148 7.99202C15.1661 8.07344 14.9389 8.20975 14.7501 8.39085C14.5612 8.57196 14.4154 8.79322 14.3236 9.03827C14.2318 9.28332 14.1963 9.54588 14.2197 9.80651V12.0715H17.5677L17.0327 15.5615H14.2197V23.9975C17.0596 23.5477 19.6459 22.0994 21.5133 19.9131C23.3807 17.7267 24.4067 14.9458 24.4067 12.0705Z"
        fill="white"
      />
    </svg>
  );
}

export { IconFacebookComponent };
